import { useSettings } from '@wu/widget-core';

const FLOATING_SPACING = 76;
const EMBED_SPACING = 50;
const EMBED_BUBBLE_SPACING = 20;

const getOffsets = (vertical: number, horizontal: number) => ({
  verticalOffset: vertical,
  horizontalOffset: horizontal
});

export const useSpacingOffset = () => {
  const {
    position,
    floatingVerticalOffset,
    floatingHorizontalOffset,
    renderThumbnailMode
  } = useSettings();

  if (renderThumbnailMode && position === 'embed-chat') {
    return getOffsets(EMBED_SPACING, EMBED_SPACING);
  }

  if (position === 'floating') {
    const finalFloatingHorizontalOffset = renderThumbnailMode
      ? FLOATING_SPACING
      : floatingHorizontalOffset;
    const finalFloatingVerticalOffset = renderThumbnailMode
      ? FLOATING_SPACING
      : floatingVerticalOffset;

    return getOffsets(
      finalFloatingVerticalOffset,
      finalFloatingHorizontalOffset
    );
  }

  if (position === 'embed-bubble') {
    return getOffsets(EMBED_BUBBLE_SPACING, EMBED_BUBBLE_SPACING);
  }

  return getOffsets(0, 0);
};
